import { HistoricalEvent } from "@customTypes/responses/lawsuit";
import { StandardTheme } from "@nectarTypes";
import { useTheme } from "emotion-theming";
import { FaUser } from "@react-icons/all-files/fa/FaUser";
import { FaCloudDownloadAlt } from "@react-icons/all-files/fa/FaCloudDownloadAlt";
import { FaFileAlt } from "@react-icons/all-files/fa/FaFileAlt";
import { FaCheckCircle } from "@react-icons/all-files/fa/FaCheckCircle";
import React from "react";

type EventIconProps = {
  eventType: HistoricalEvent["type"];
  size?: number;
};

const EventIcon: React.FC<EventIconProps> = ({ eventType, size = 16 }) => {
  const theme = useTheme<StandardTheme>();

  const iconColor = theme.colors.gray500;

  switch (eventType) {
    case "DONE_TASK":
      return <FaCheckCircle color={iconColor} size={size} />;
    case "CLIPPING":
      return <FaFileAlt color={iconColor} size={size} />;
    case "MANUALLY":
      return <FaUser color={iconColor} size={size} />;
    case "AUTOMATIC_LAWSUIT":
      return <FaCloudDownloadAlt color={iconColor} size={size} />;
    default:
      return <FaCloudDownloadAlt color={iconColor} size={size} />;
  }
};

export default EventIcon;
